import { render, staticRenderFns } from "./BirConsolidatedReport.vue?vue&type=template&id=7eb0938a&"
import script from "./BirConsolidatedReport.vue?vue&type=script&lang=js&"
export * from "./BirConsolidatedReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports